import React from "react";
import { IoCheckmarkCircleOutline } from "react-icons/io5";
import { BiCoinStack } from "react-icons/bi";
import { IoLockClosedOutline } from "react-icons/io5";
import { BiLike } from "react-icons/bi";
import img1 from "../../../../assets/img/Services/IAMSecuritySolutions/regulations.jpg";
import { FaMap, FaSearchMinus, FaClipboardList } from "react-icons/fa";

export default function PaymentServices() {
  return (
    <div className="container mx-auto px-4 py-12 md:py-12 md:px-10">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
        <div className="space-y-8">
          <div className="space-y-4">
            <h1 className="text-4xl md:text-5xl font-bold leading-tight text-gray-900">
              Regulatory Mapping and Gap Analysis
            </h1>
            <p className="text-lg text-gray-600">
              Identify gaps in your current compliance posture and develop a clear roadmap to address them.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
            {/* Feature 1 */}
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <FaMap className="w-6 h-6 text-indigo-600" />
                <h3 className="font-semibold text-gray-900">Regulatory Mapping</h3>
              </div>
              <p className="text-gray-600 text-sm">
                Align organizational processes with specific regulations such as GDPR, HIPAA, and PCI DSS.
              </p>
            </div>

            {/* Feature 2 */}
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <FaSearchMinus className="w-6 h-6 text-indigo-600" />
                <h3 className="font-semibold text-gray-900">Gap Analysis</h3>
              </div>
              <p className="text-gray-600 text-sm">
                Assess vulnerabilities and compliance shortfalls to prioritize corrective actions.
              </p>
            </div>

            {/* Feature 3 */}
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <FaClipboardList className="w-6 h-6 text-indigo-600" />
                <h3 className="font-semibold text-gray-900">Custom Compliance Frameworks</h3>
              </div>
              <p className="text-gray-600 text-sm">
                Develop tailored frameworks for industry-specific requirements.
              </p>
            </div>
          </div>
        </div>

        <div className="relative h-[500px] rounded-3xl overflow-hidden">
          <img
            src={img1}
            alt="Regulatory Mapping and Gap Analysis"
            className="object-cover w-full h-full rounded-3xl"
          />
        </div>
      </div>
    </div>
  );
}
